import { getPromiseWithResolvers } from "@/utils/getPromiseWithResolvers";
import Swal from "sweetalert2";

export async function AreYouSureAboutThat(message: string, title?: string, confirmText?: string, cancelText?: string) {
    const { promise, resolve } = getPromiseWithResolvers();
    void Swal.fire({
        title: title ?? 'Tem certeza?',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: confirmText ?? 'Sim!',
        cancelButtonText: cancelText ?? 'Cancelar',
    }).then(res => resolve(res.isConfirmed))
    return await promise;
}


export async function AreYouSureAboutDeleting(message: string, title?: string, confirmText?: string, cancelText?: string, confirmBgColor?: string, cancelBgColor?: string) {
    const { promise, resolve } = getPromiseWithResolvers();
    void Swal.fire({
        title: title ?? 'Tem certeza?',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: confirmText ?? 'Sim, deletar!',
        cancelButtonText: cancelText ?? 'Cancelar',
        confirmButtonColor: confirmBgColor,
        cancelButtonColor: cancelBgColor,
    }).then(res => resolve(res.isConfirmed));
    return await promise;
}